import $ from 'jquery';

import { uri } from 'utils';
import classnames from 'consts/classnames';

const URL_PAGE_PARAMETER_ID = 'page';
const FIRST_PAGE = 1;

const paginationLoadMoreButton = () => {
    const { IS_LOADING } = classnames;
    const container = document.querySelector('.js-pagination');

    if (!container) {
        return;
    }

    const loadMoreButton = container.querySelector(
        '.js-pagination-load-more-button'
    );

    if (!loadMoreButton) {
        return;
    }

    const loadMoreButtonLoaderPlaceholder = loadMoreButton.closest(
        '.js-pagination-load-more-button-loader-placeholder'
    );

    let currentPage = getCurrentPageFromURL() || FIRST_PAGE;

    bindClickToButton();

    function getCurrentPageFromURL() {
        const urlParameter = uri.getParams()[URL_PAGE_PARAMETER_ID];

        if (!urlParameter) {
            return null;
        }

        const sanitized = parseInt(urlParameter, 10);

        if (Number.isNaN(sanitized)) {
            return null;
        }

        return sanitized;
    }

    function showButtonLoader() {
        loadMoreButton.classList.add(IS_LOADING);

        if (loadMoreButtonLoaderPlaceholder) {
            loadMoreButtonLoaderPlaceholder.classList.add(IS_LOADING);
        }
    }

    function hideButtonLoader() {
        loadMoreButton.classList.remove(IS_LOADING);

        if (loadMoreButtonLoaderPlaceholder) {
            loadMoreButtonLoaderPlaceholder.classList.remove(IS_LOADING);
        }
    }

    /**
     * Update panel is not available during FE development, therefore
     * we just fake it by showing a loader animation
     * @returns void
     */
    function fakeLocalDevelopmentUpdatePanelStart() {
        if (typeof isPRODUCTION !== 'undefined' && !isPRODUCTION) {
            setTimeout(() => {
                hideButtonLoader();
            }, 1000);
        }
    }

    function handleButtonClick() {
        currentPage += 1;
        const params = uri.getParams();

        const formattedURL = uri.format({
            query: {
                ...params,
                [URL_PAGE_PARAMETER_ID]: currentPage
            }
        });

        // no need to update (write into Browser history)
        if (formattedURL === window.location.search) {
            return;
        }

        uri.replaceURL(formattedURL);

        showButtonLoader();

        fakeLocalDevelopmentUpdatePanelStart();
    }

    function bindClickToButton() {
        // we will attach new listeners once the HTML is updated via Update Panel
        loadMoreButton.removeEventListener('click', handleButtonClick);
        loadMoreButton.addEventListener('click', handleButtonClick);
    }
};

$(() => {
    paginationLoadMoreButton();

    Sys.WebForms.PageRequestManager.getInstance().add_endRequest(() => {
        paginationLoadMoreButton();
    });
});
